/**
 * keepAlive.js
 * Ping le backend toutes les 10 min pour éviter le cold start Render
 */
// `/health` vit a la RACINE du service, pas sous /api · on retire le suffixe
// du repli comme des autres pages qui visent hors-API (MEMBRE-DELETE-001).
const BASE = (import.meta.env.VITE_API_URL || 'https://backend-pued.onrender.com/api').replace(/\/api\/?$/, '')
const API = `${BASE}/health`
const INTERVAL = 10 * 60 * 1000 // 10 min

export function startKeepAlive() {
  const ping = () => {
    fetch(API, { method: 'GET' })
      .then(() => {})
      .catch(() => {})
  }

  ping() // ping immédiat au démarrage
  return setInterval(ping, INTERVAL)
}
